import MenuIcon from '@mui/icons-material/Menu'
import { AppBar, Box, IconButton, SxProps, Theme, Toolbar } from '@mui/material'

import { headerStyle } from 'common/styles'
import Logo from 'components/Logo'
import { StartOverButton } from 'components/StartOverButton'
import BackButton from 'components/StepContainer/BackButton'
import StyledWrap from 'components/StyledWrap'
import { useSessionDispatch, useSessionState } from 'context/Session'
import { Divider } from 'elements/Divider'
import { useCompany } from 'utils/company'
import { useFlow } from 'utils/flow'
import { useCurrentPage } from 'utils/hook'

import ProgressBar from './ProgressBar'

const styles: Record<string, SxProps<Theme>> = {
  backButton: {
    position: 'absolute',
    left: 10,
    display: {
      xs: 'block',
      sm: 'none',
    },
  },
  name: {
    flexGrow: {
      xs: 1,
      sm: 0,
    },
    color: '#201D25',
    fontWeight: '600',
  },
}

interface HeaderProps {
  openDrawer: () => void
}

export default function Header({ openDrawer }: HeaderProps): JSX.Element {
  const { appBar, toolbar, iconBar } = headerStyle

  const { data: flow } = useFlow()
  const { data: company } = useCompany()
  const [dispatch] = useSessionDispatch()
  const { path, isSubmitted } = useSessionState()
  const { longest_path_length: longestPath } = useCurrentPage()

  const { hide_progress_bar: hideProgressBar } = flow!

  const onClick = (): void => dispatch({ type: 'popStep' })

  const backButton = !(path.length === 0 || !!isSubmitted)
  const progress = (path.length / (path.length + longestPath)) * 100

  return (
    <StyledWrap elementName="Header">
      <AppBar className="header" position="fixed" sx={appBar}>
        <Toolbar sx={toolbar}>
          {backButton && (
            <Box className="prev-page-btn-wrap" sx={styles.backButton}>
              <BackButton onClick={onClick} />
            </Box>
          )}
          <Logo logo={company?.logo ?? null} />
          <Box className="header-btn-wrap" sx={iconBar}>
            <StartOverButton />
            <IconButton className="menu-btn" onClick={openDrawer}>
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
        {!hideProgressBar && <ProgressBar value={progress} />}
        <Divider />
      </AppBar>
    </StyledWrap>
  )
}
